var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLinkalianza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 498 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc4c02;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18505",
    "data-name": "Group 18505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18503",
    "data-name": "Group 18503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17857",
    "data-name": "Path 17857",
    d: "M70.26,115.79v16.93H0V40.31H23v75.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17858",
    "data-name": "Path 17858",
    d: "M161.13,40.31v92.41h-23V40.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17859",
    "data-name": "Path 17859",
    d: "M487.31,40.31l-30,43.46,40.71,49H469.3L432.76,89.39v43.33h-23V40.31h23V81.92l29.3-41.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18502",
    "data-name": "Group 18502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17860",
    "data-name": "Path 17860",
    className: "cls-1",
    d: "M333.51,132.72H311.08l0-47.26a24.73,24.73,0,1,0-49.46-.31v.31l0,47.26H239.19l0-47.26a47.16,47.16,0,1,1,94.32-.61c0,.21,0,.41,0,.61Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1300",
    "data-name": "Ellipse 1300",
    cx: 149.66,
    cy: 13.43,
    rx: 13.4,
    ry: 13.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18504",
    "data-name": "Group 18504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17861",
    "data-name": "Path 17861",
    d: "M55.16,191.88,53,186.8H42l-2.17,5.08h-3L46,171h3l9.24,20.93Zm-12.08-7.69h8.77L47.43,174Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17862",
    "data-name": "Path 17862",
    d: "M70.54,169.69h2.78v22.19H70.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17863",
    "data-name": "Path 17863",
    d: "M90.86,170.26a1.92,1.92,0,0,1,0,2.57,1.75,1.75,0,0,1-2.47,0,1.92,1.92,0,0,1,0-2.57A1.75,1.75,0,0,1,90.86,170.26Zm-2.61,5.8H91v15.82H88.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17864",
    "data-name": "Path 17864",
    d: "M115.42,191.88v-2.21c-1.18,1.55-3,2.33-5.52,2.33a6.27,6.27,0,0,1-2.88-.63,4.62,4.62,0,0,1-1.91-1.73,4.81,4.81,0,0,1-.67-2.48,4.08,4.08,0,0,1,1.57-3.37,7,7,0,0,1,4.37-1.27h5v-.75a3.29,3.29,0,0,0-1-2.58,4.32,4.32,0,0,0-3-.91,8.49,8.49,0,0,0-4.86,1.7l-1.16-1.92a14.37,14.37,0,0,1,3.15-1.6,10.53,10.53,0,0,1,3.44-.49,6.54,6.54,0,0,1,4.56,1.45,5.23,5.23,0,0,1,1.64,4.05l0,10.4Zm-1.66-3.13a3.68,3.68,0,0,0,1.63-2.49v-1.59h-4.62a5.48,5.48,0,0,0-2.79.57,2,2,0,0,0-.91,1.8A2.33,2.33,0,0,0,108,189a4,4,0,0,0,2.48.72,5.65,5.65,0,0,0,3.29-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17865",
    "data-name": "Path 17865",
    d: "M145.59,177.6a6.17,6.17,0,0,1,1.58,4.51v9.77H144.4v-9a4.23,4.23,0,0,0-1.12-3.12,4.15,4.15,0,0,0-3.09-1.12,4.76,4.76,0,0,0-3.44,1.36,5.4,5.4,0,0,0-1.51,3.45v8.46h-2.77V176.07h2.77v3.34c1.06-2.25,3-3.4,6-3.44A5.78,5.78,0,0,1,145.59,177.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17866",
    "data-name": "Path 17866",
    d: "M160.14,176.06l12.68,0v2l-9.54,11.51,9.78,0v2.3l-13.18,0v-2l9.51-11.51-9.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17867",
    "data-name": "Path 17867",
    d: "M195.59,191.88v-2.21q-1.76,2.33-5.51,2.33a6.24,6.24,0,0,1-2.88-.63,4.56,4.56,0,0,1-1.91-1.73,4.72,4.72,0,0,1-.67-2.48,4.05,4.05,0,0,1,1.57-3.37,7,7,0,0,1,4.36-1.27h5v-.75a3.25,3.25,0,0,0-1-2.58,4.3,4.3,0,0,0-3-.91,8.47,8.47,0,0,0-4.86,1.7l-1.16-1.92a14.3,14.3,0,0,1,3.14-1.6,10.63,10.63,0,0,1,3.45-.49,6.57,6.57,0,0,1,4.56,1.45,5.23,5.23,0,0,1,1.64,4.05l0,10.4Zm-1.65-3.13a3.7,3.7,0,0,0,1.62-2.49v-1.59h-4.62a5.52,5.52,0,0,0-2.79.57,2,2,0,0,0-.91,1.8,2.34,2.34,0,0,0,.93,1.94,4,4,0,0,0,2.47.72A5.7,5.7,0,0,0,193.94,188.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17868",
    "data-name": "Path 17868",
    d: "M230.09,171h13.6l0,2.6H233v6.88h9.63V183H233v8.85h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17869",
    "data-name": "Path 17869",
    d: "M258.73,170.26a1.92,1.92,0,0,1,0,2.57,1.76,1.76,0,0,1-2.48,0,1.94,1.94,0,0,1,0-2.57A1.76,1.76,0,0,1,258.73,170.26Zm-2.61,5.8h2.77v15.82h-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17870",
    "data-name": "Path 17870",
    d: "M286.77,177.6a6.17,6.17,0,0,1,1.58,4.51v9.77h-2.77v-9a3.89,3.89,0,0,0-3.48-4.24,4.45,4.45,0,0,0-.73,0,4.76,4.76,0,0,0-3.44,1.36,5.33,5.33,0,0,0-1.5,3.45v8.46h-2.78V176.07h2.78v3.34q1.57-3.37,6-3.44A5.78,5.78,0,0,1,286.77,177.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17871",
    "data-name": "Path 17871",
    d: "M312.29,191.88v-2.21q-1.76,2.33-5.51,2.33a6.24,6.24,0,0,1-2.88-.63,4.62,4.62,0,0,1-1.91-1.73,4.72,4.72,0,0,1-.67-2.48,4.05,4.05,0,0,1,1.57-3.37,7,7,0,0,1,4.37-1.27h5v-.75a3.25,3.25,0,0,0-1-2.58,4.34,4.34,0,0,0-3-.91,8.49,8.49,0,0,0-4.86,1.7l-1.16-1.92a14.3,14.3,0,0,1,3.14-1.6,10.63,10.63,0,0,1,3.45-.49,6.56,6.56,0,0,1,4.56,1.45,5.23,5.23,0,0,1,1.64,4.05l0,10.4Zm-1.65-3.13a3.7,3.7,0,0,0,1.62-2.49v-1.59h-4.62a5.52,5.52,0,0,0-2.79.57,2,2,0,0,0-.9,1.8,2.31,2.31,0,0,0,.92,1.94,4,4,0,0,0,2.47.72A5.7,5.7,0,0,0,310.64,188.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17872",
    "data-name": "Path 17872",
    d: "M342.47,177.6a6.17,6.17,0,0,1,1.58,4.51v9.77h-2.77v-9a3.9,3.9,0,0,0-3.49-4.24,4.33,4.33,0,0,0-.72,0,4.76,4.76,0,0,0-3.44,1.36,5.34,5.34,0,0,0-1.51,3.45v8.46h-2.77V176.07h2.77v3.34c1.06-2.25,3.05-3.4,6-3.44A5.78,5.78,0,0,1,342.47,177.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17873",
    "data-name": "Path 17873",
    d: "M364.92,178.45a5.57,5.57,0,0,0-2.76.69,4.86,4.86,0,0,0-1.89,2,5.86,5.86,0,0,0-.69,2.9,6.09,6.09,0,0,0,.67,2.9,4.91,4.91,0,0,0,1.85,2,5.12,5.12,0,0,0,2.7.7,7.16,7.16,0,0,0,2.74-.51,5.26,5.26,0,0,0,2-1.46l1.58,1.61a7,7,0,0,1-2.73,2.06,9.26,9.26,0,0,1-3.74.72,8.11,8.11,0,0,1-4.09-1,7.23,7.23,0,0,1-2.79-2.83,9.13,9.13,0,0,1,0-8.3,7.25,7.25,0,0,1,2.79-2.84,8.11,8.11,0,0,1,4.09-1,10,10,0,0,1,3.59.61,7.08,7.08,0,0,1,2.67,1.78l-1.52,1.91A6.29,6.29,0,0,0,364.92,178.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17874",
    "data-name": "Path 17874",
    d: "M387.09,170.26a1.94,1.94,0,0,1,0,2.57,1.76,1.76,0,0,1-2.48,0,1.94,1.94,0,0,1,0-2.57A1.76,1.76,0,0,1,387.09,170.26Zm-2.61,5.8h2.77v15.82h-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17875",
    "data-name": "Path 17875",
    d: "M413.88,178.14a8.91,8.91,0,0,1,1.88,6q0,.6,0,.9H403.26a5.36,5.36,0,0,0,1.78,3.37,5.22,5.22,0,0,0,3.56,1.26,6.5,6.5,0,0,0,2.61-.51,6.32,6.32,0,0,0,2.1-1.43l1.52,1.58a7.88,7.88,0,0,1-2.8,1.94,9.07,9.07,0,0,1-3.64.69,8.27,8.27,0,0,1-4.13-1,7,7,0,0,1-2.8-2.82,9.11,9.11,0,0,1,0-8.3,7.25,7.25,0,0,1,2.79-2.84,8,8,0,0,1,4.08-1A6.93,6.93,0,0,1,413.88,178.14Zm-.63,4.77a4.58,4.58,0,0,0-4.51-4.65l-.38,0a4.93,4.93,0,0,0-3.47,1.25,5.28,5.28,0,0,0-1.66,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17876",
    "data-name": "Path 17876",
    d: "M433.89,176.89a6.52,6.52,0,0,1,3.39-.92v2.69a5.08,5.08,0,0,0-5.58,4.53l0,.35v8.34H428.9V176.06h2.77v3.41A5.68,5.68,0,0,1,433.89,176.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17877",
    "data-name": "Path 17877",
    d: "M458.6,191.88v-2.21q-1.75,2.33-5.51,2.33a6.24,6.24,0,0,1-2.88-.63,4.62,4.62,0,0,1-1.91-1.73,4.72,4.72,0,0,1-.67-2.48,4.05,4.05,0,0,1,1.57-3.37,7,7,0,0,1,4.37-1.27h5v-.75a3.28,3.28,0,0,0-1-2.58,4.34,4.34,0,0,0-3-.91,8.49,8.49,0,0,0-4.86,1.7l-1.16-1.92a14.3,14.3,0,0,1,3.14-1.6,10.63,10.63,0,0,1,3.45-.49,6.56,6.56,0,0,1,4.56,1.45,5.23,5.23,0,0,1,1.64,4.05l0,10.4ZM457,188.75a3.7,3.7,0,0,0,1.62-2.49v-1.59H454a5.52,5.52,0,0,0-2.79.57,2,2,0,0,0-.91,1.8,2.34,2.34,0,0,0,.93,1.94,4,4,0,0,0,2.48.72A5.69,5.69,0,0,0,457,188.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkalianza);
export default __webpack_public_path__ + "static/media/logo_linkalianza.31a06d3bf46e63dae739cc27791fb3df.svg";
export { ForwardRef as ReactComponent };